import { useCallback, useEffect, useRef, useState } from "react";
import { resolveToken } from "./utils";

export function useScanFlow(process, duration = 1600) {
  const [phase, setPhase] = useState("idle");
  const [result, setResult] = useState(null);
  const busy = useRef(false);
  const last = useRef({ token: null, until: 0 });
  const timers = useRef([]);

  useEffect(() => () => timers.current.forEach(clearTimeout), []);

  const trigger = useCallback((raw, { fromCamera = false } = {}) => {
    if (busy.current) return;
    const token = resolveToken(raw);
    if (fromCamera && token && last.current.token === token && Date.now() < last.current.until) return;
    busy.current = true;
    setPhase("scanning");
    timers.current.push(setTimeout(async () => {
      let r;
      try {
        r = await process(token, raw);
      } catch (e) {
        r = { status: "error", message: e?.message };
      }
      setResult(r);
      setPhase("result");
      last.current = { token, until: Date.now() + duration + 3000 };
      timers.current.push(setTimeout(() => {
        setPhase("idle");
        setResult(null);
        busy.current = false;
      }, duration));
    }, fromCamera ? 180 : 420));
  }, [process, duration]);

  return { phase, result, trigger };
}
